import { KeyboardDatePicker } from '@material-ui/pickers';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  keyboardDatePicker: {
    paddingRight: '0',
  },
  datepicker: {
    '& *': {
      padding: '0',
      margin: '0',
      border: '0',
    },
    '& .MuiInputBase-root': {
      fontFamily: 'NotoSans-Medium',
      color: '#2e4469',
      height: '3.5rem',
      lineHeight: '3.5rem',
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
      borderRadius: '0.625rem',
      border: 'solid 1px #e4e7eb',
      backgroundColor: '#fff',
      padding: '0 1.25rem',
      fontSize: '1rem',
    },
    '& .MuiInputBase-input': {
      height: '3.5rem',
      lineHeight: '3.5rem',
    },
    '& :focus': {
      backgroundColor: 'unset',
    },
    '& :before': {
      content: 'none',
    },
    ':before': {
      content: 'none !important',
    },
    '& :after': {
      content: 'none',
    },
  },
  dialogBodyDatePicker: {
    '& .MuiInputBase-root': {
      borderRadius: '0.625rem',
      border: '1px solid #E4E7EB',
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      color: theme.palette.font.main,
      fontWeight: 'normal',
      height: '3.25rem',
    },
    '& .MuiButtonBase-root': {
      borderRadius: '0',
      '&:hover': {
        backgroundColor: theme.palette.font.white,
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      display: 'none',
    },
    '& .MuiIconButton-root': {
      padding: '9px 12px',
    },
  },
}));

const CustomKeyboardDatePicker = (props) => {
  const { type = 'normal', ...rest } = props;
  const classes = useStyles();
  return (
    <KeyboardDatePicker
      {...rest}
      className={type === 'normal' ? classes.keyboardDatePicker : classes.dialogBodyDatePicker}
    />
  );
};

export default CustomKeyboardDatePicker;
